import React from 'react';
import Popup from 'reactjs-popup';
import { Button } from 'react-bootstrap';

import '../styles/PopUps.css';

const ACHWarningPopUp = (props) => {
    
    return(
        <Popup open = {true}  modal closeOnDocumentClick={false}> 
            {(close) => (
                <div className='ACHWarningContainer'> 
                    <h4 className="ACHWarningHeader">Multiple Address Warning</h4>
                    <div className="ACHWarningContent">
                        There are multiple remit addresses related to your supplier ID. ACH
                        payments will be deposited to the same bank account for all remit addresses.
                        
                    </div>
                    <br/>
                    <div className="ACHWarningContent" id='ACHWarningBottom'>
                        Click Continue if you wish to proceed with your request. If you need assistance with this
                        request, visit the Contact Us page and send a message to the Supplier Inquiry team.
                    </div>
                    <Button className="popup-buttons" onClick={() => {
                        close();
                        props.cancelACHWarning(true);
                    }} >Continue</Button> 
                    <Button className="popup-buttons" onClick={() => {
                        props.cancelACHWarning(false);
                        close();
                        }}>
                        Cancel
                        </Button>
                </div> 
            )}
        </Popup>
    ); 
};
export default ACHWarningPopUp;
    